import { render, staticRenderFns } from "./MembershipBenefit.vue?vue&type=template&id=009fdaf4&scoped=true"
import script from "./MembershipBenefit.vue?vue&type=script&lang=js"
export * from "./MembershipBenefit.vue?vue&type=script&lang=js"
import style0 from "./MembershipBenefit.vue?vue&type=style&index=0&id=009fdaf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009fdaf4",
  null
  
)

export default component.exports